export const SET_FORM_DETAILS = 'SET_FORM_DETAILS';
export const UPDATE_FORM_STEP = 'UPDATE_FORM_STEP';
export const RESET_NEW_FORM = 'RESET_NEW_FORM';
export const SET_FORM_FIELDS = 'SET_FORM_FIELDS';
export const ADD_MULTIPLE_FIELDS = 'ADD_MULTIPLE_FIELDS';
export const EDIT_FORM_FIELDS = 'EDIT_FORM_FIELDS';
export const DELETE_FORM_FIELDS = 'DELETE_FORM_FIELDS';
export const NEW_FORM_ASYNC_START = 'NEW_FORM_ASYNC_START';
export const SET_FORM_CONFIGURATION = 'SET_FORM_CONFIGURATION';
export const SET_UPDATING_FORM_EDIT = 'SET_UPDATING_FORM_EDIT';
export const SET_EDIT_FORM_DETAILS = 'SET_EDIT_FORM_DETAILS';
export const FETCH_EDIT_FORM_START = 'FETCH_EDIT_FORM_START';